import SearchIcon from './component.jsx'
export default SearchIcon
